import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";
import { Hooks } from "@xt/xtbase";
import step3Img from "@/assets/img/cfd-guide/guide1.png";
import lineImg from "@/assets/img/cfd-guide/line.png";
import store from "store";
import { useCfdGuideStageRect } from "./useCfdGuideStageRect";
import styles from "./StandardGuideStep3.module.scss";

const { useTranslation } = Hooks;

export type StandardGuideStep3Props = {
  onSkip: () => void;
  onNext: () => void;
};

const DESIGN_WIDTH = 375;

function getScale(): number {
  if (typeof window === "undefined") return 1;
  const w = window.innerWidth || DESIGN_WIDTH;
  return w / DESIGN_WIDTH;
}

const StandardGuideStep3: React.FC<StandardGuideStep3Props> = ({ onSkip, onNext }) => {
  const t = useTranslation();
  const { name } = store.market;

  const scale = useMemo(() => getScale(), []);

  // 获取当前杠杆值（从 store 或默认值）
  const leverage = useMemo(() => {
    // 这里可以从 store 获取实际杠杆值，暂时使用默认值
    return "100";
  }, []);

  const imgSrc = (step3Img as any)?.src || (step3Img as any);
  const lineImgSrc = (lineImg as any)?.src || (lineImg as any);

  const anchor = useCfdGuideStageRect('[data-guide-target="leverageRow"]');

  return (
    <div style={{ ["--sg-scale" as any]: scale }}>
        {/* 高亮 + 提示框：与真实杠杆行对齐 */}
        <div
          className={styles.highlightAndTipWrapper}
          style={
            anchor
              ? {
                  position: "fixed",
                  top: anchor.top,
                  left: anchor.left,
                  width: anchor.width,
                  zIndex: 10001,
                }
              : { visibility: "hidden" as const }
          }
        >
          <div className={styles.highlightRect} style={anchor ? { minHeight: anchor.height } : undefined}>
            <span className={styles.leverageLabel}>{t("cfd.leverage")}</span>
            <div className={styles.leverageSelect}>
              <span className={styles.leverageValue}>{leverage}X</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
                <path d="M10 0H0L5 6L10 0Z" fill="rgba(255, 255, 255, 0.56)" />
              </svg>
            </div>
          </div>
          <div className={styles.tip}>
          <div className={styles.tipBg}>
            <div className={styles.tipText}>
              <div className={styles.tipTitle}>{t("cfd.guide.standard.step3.title")}</div>
              <div className={styles.tipDesc}>{t("cfd.guide.standard.step3.desc")}</div>
            </div>
            <img className={styles.tipImg} src={imgSrc} alt="" />
          </div>
          <div className={styles.star1} />
          <div className={styles.star2} />
          <img className={styles.lineImg} src={lineImgSrc} alt="" />
        </div>
        </div>

        {/* 底部按钮 */}
        <div className={styles.btnGroup}>
          <button type="button" className={`${styles.btn} ${styles.btnPrimary}`} onClick={onNext}>
            {`${t("cfd.guide.next")} 3/7`}
          </button>
          <button type="button" className={`${styles.btn} ${styles.btnGhost}`} onClick={onSkip}>
            {t("cfd.guide.skip")}
          </button>
        </div>
    </div>
  );
};

export default observer(StandardGuideStep3);
